// extracted by mini-css-extract-plugin
export default {"container":"NylasConnect_container__SR0K-","title":"NylasConnect_title__gwoBD","subTitle":"NylasConnect_subTitle__DUs+i"};